import {Directive, Input} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, ValidationErrors, Validator} from '@angular/forms';

@Directive({
    selector: '[appMaxNumber]',
    providers: [{provide: NG_VALIDATORS, useExisting: MaxNumberDirective, multi: true}]

})
export class MaxNumberDirective implements Validator {

    @Input() appMaxNumber: number;

    constructor() {
    }

    validate(control: AbstractControl): ValidationErrors | null {
        return this.validateValue(control);
    }

    private validateValue(control: AbstractControl) {
        return control.value <= this.appMaxNumber ? null : {appMaxNumber: true};
    }
}
